// eslint-disable-next-line
import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import Actions from "../../Redux/Actions"
import { gtmClickHandler } from "../../Utils/gtm"

const WithModuleSplashPageFunctionality = ({
  children,
  unlockedUserModules,
  navigation,
  modules,
  history,
  beginModule,
  match
}) => {
  const currentUserModule = (unlockedUserModules || []).find((um) => {
    return um.module_id === navigation.currentModuleId
  })

  // A module is locked if the previous module (in course order) has not been completed.
  const allIds = modules?.allIds || []
  const currentIndex = allIds.indexOf(navigation.currentModuleId)
  const previousModuleId = currentIndex > 0 ? allIds[currentIndex - 1] : null
  const previousUserModule = previousModuleId
    ? (unlockedUserModules || []).find((um) => um.module_id === previousModuleId)
    : null
  const isLocked =
    previousModuleId != null &&
    (!previousUserModule ||
      (previousUserModule.completed !== 1 && previousUserModule.completed !== true))

  const getButtonText = (userModule) => {
    if (isLocked || !userModule) {
      return "Locked"
    }
    const { started, completed } = userModule
    // If completed, show "Edit" regardless of started status
    if (completed === 1 || completed === true) {
      return "Edit"
    }
    // If started but not completed, show "Resume"
    if (started === 1 || started === true) {
      return "Resume"
    }
    // Otherwise, show "Begin"
    return "Begin"
  }

  const buttonText = getButtonText(currentUserModule)
  const canInteract = !isLocked && currentUserModule

  const clickHandler = () => {
    if (!canInteract) return
    beginModule(history)
    gtmClickHandler({
      name: `${buttonText} ClickedEvent`,
      data: {
        action: `${buttonText} Clicked`,
        category: "PYP Engagement",
        label: match.params.module
      }
    })
  }

  return (
    <>
      {children({
        buttonText,
        clickHandler,
        foundUnlockedModule: canInteract ? currentUserModule : null,
        isLocked
      })}
    </>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    unlockedUserModules: state.pyp.unlockedUserModules,
    navigation: state.pyp.navigation,
    modules: state.pyp.modules
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WithModuleSplashPageFunctionality)
)
